module.exports = __webpack_public_path__ + "static/media/10 These Days.d02e5883.mp3";